export default () => {
	const togglers = document.querySelectorAll('.toggler') as NodeListOf<HTMLButtonElement>
	const headerNav = document.querySelector('.header__nav') as HTMLElement
	const nav = document.querySelector('.nav') as HTMLElement

	if (!nav || !togglers || !headerNav) return

	const list = nav.querySelector('.nav__list') as HTMLUListElement
	const items = nav.querySelectorAll('.nav__list > .nav__item') as NodeListOf<HTMLLIElement>

	if (!list || !items) return

	items.forEach(item => {
		const sublist = item.querySelector('.nav__sublist') as HTMLUListElement
		const subHeader = item.querySelector('.nav__subheader') as HTMLLIElement
		const label = item.querySelector('.nav__label') as HTMLLabelElement

		if (!sublist || !subHeader || !label) return

		label.onclick = e => {
			if (sublist.classList.contains('active')) return
			e.preventDefault()
			list.classList.add('active')
			sublist.classList.add('active')

		}

		subHeader.onclick = () => {
			list.classList.remove('active')
			sublist.classList.remove('active')
		}

	})

	togglers.forEach(toggler => {
		toggler.onclick = () => {
			headerNav.classList.toggle('active')
		}
	})
}
